import { Stack, Text } from "@certn/cascadia";
import { Divider, Toggle } from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useFlags } from "launchdarkly-react-client-sdk";

type InstantEmploymentVerificationToggleProps = {
  isReadOnly?: boolean;
  digital_verification: boolean;
  onChange?: (v: boolean) => void;
  showBottomDivider?: boolean;
};

export const InstantEmploymentVerificationToggle = ({
  isReadOnly,
  digital_verification,
  onChange,
  showBottomDivider = false,
}: InstantEmploymentVerificationToggleProps) => {
  const { t } = useTranslation();
  const { releaseInstantEmploymentVerification } = useFlags();

  if (!releaseInstantEmploymentVerification) return null;

  return (
    <Stack gap="space-4">
      <Divider />
      <Text style="global/heading-medium">
        <Trans>Verification preferences</Trans>
      </Text>
      <Toggle
        card
        isSelected={digital_verification}
        onChange={onChange}
        isDisabled={isReadOnly || !onChange}
        testID="enable-digital-verification"
        description={t(
          "Automatically verifies UK employment details using secure data sources where available, helping reduce turnaround times and manual checks. Applies to employment within the last 6 years, and where digital verification isn’t available, standard verification methods will be used."
        )}
      >
        <Text style="input/label">
          {t("Enable digital employment verification")}
        </Text>
      </Toggle>
      {showBottomDivider && <Divider marginTop="space-2" />}
    </Stack>
  );
};
